module.exports = __webpack_public_path__ + "img/tuyau_i.6657299d.svg";